import React from 'react';
import { SummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem';
import { SigningAppointmentSummaryView } from './SigningAppointmentSummaryView';
import { ePartyPurpose } from '../../../../../ui-toolkit/enums/ePartyPurpose';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';
import { useListSortedSigningAppointments } from '../../../../../utilities/order/summary/useListSortedSigningAppointments';
import { eTransactionCategory } from '../../../../../ui-toolkit/enums/eTransactionType';

export const SellerAppointments: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  const isPurchase = data.transaction.transaction_category === eTransactionCategory.Purchase;
  const hasSellers = data.parties.some((t) => t.purpose === ePartyPurpose.seller);

  const { isSigningAppointmentsLoading, sellerAppointments } = useListSortedSigningAppointments();

  if (!isPurchase) {
    return null;
  }
  if (!hasSellers) {
    return null;
  }

  return (
    <SummaryItem label={`Signing Appointment (Seller)`} tab={`summary`} isLoading={isSigningAppointmentsLoading}>
      {sellerAppointments.map((sellerAppointment) => (
        <SigningAppointmentSummaryView
          key={`${sellerAppointment.id}`}
          appointment={sellerAppointment}
          partyType={ePartyPurpose.seller}
        />
      ))}
    </SummaryItem>
  );
};
